import { cn } from "../../../lib/cn";

/**
 * Skeleton — placeholder de carga genérico.
 *
 * Primitiva única, sin variantes especializadas: cada pantalla la combina
 * (varios Skeleton, distintos tamaños) para componer su propio esqueleto.
 *
 * @example
 * <Skeleton className="h-4 w-2/3" />
 * <Skeleton width={40} height={40} className="rounded-full" />
 *
 * `width`/`height` aceptan número (px) o string (cualquier unidad CSS) y se
 * aplican inline. El tamaño también puede darse por completo con `className`
 * (h-4 w-24, etc.). `rounded` por defecto; overráis con className.
 */
export function Skeleton({ width, height, className, style, ...props }) {
  const dim = (v) => (typeof v === "number" ? `${v}px` : v);
  return (
    <div
      className={cn("animate-pulse rounded bg-slate-100", className)}
      style={{ width: dim(width), height: dim(height), ...style }}
      {...props}
    />
  );
}
